import { LayoutController } from "onearm";

export class PayTablesPageController extends LayoutController {
    constructor(layout, { paytables = {}, scatter = {} } = {}) {
        super(layout);

        this.setupPaytables(paytables);
        this.setupPaytables(scatter);
    }


    setupPaytables(paytables) {
        for (const [symbolName, paysTable] of Object.entries(paytables)) {
            const symbolsContainers = this.findAll(symbolName.replace("S", "SymbolPay"));

            symbolsContainers.forEach(symbolContainer => {
                const pays = symbolContainer.find('pays');

                let index = 0;
                for (const [amount,payout] of Object.entries(paysTable)) {
                    if ( pays.children[index]) {
                        pays.children[index].text = `${amount} ${payout}`;
                    }

                    index += 1;
                }
            });
        }
    }
}
